export default __webpack_public_path__ + "static/media/share.666fa7fd.gif";